import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Order, OrderListItem } from './order';
import { OrderService } from './order.service';
import { CustomerService } from '../customer/customer.service';
import { Customer } from '../customer/customer';
import { GUILogicService } from '../guilogic.service';

import { Message, ConfirmationService } from 'primeng/primeng';
import { StockSearchRequest } from '../stock/stock-search';
import { ArticleService } from '../article/article.service';
import { Article } from '../article/article';
import { StockSearchService } from '../stock/stock-search.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css'],
  providers: [ConfirmationService]
})
export class OrderComponent implements OnInit {
  orderMap: Order[];
  orderList: OrderListItem[];
  msgs: Message[];
  selectedOrder: OrderListItem;
  selectedOrderCustomer: Customer;

  dataChartKPI: any;

  constructor(private orderService: OrderService, private router: Router,
    private confirmationService: ConfirmationService, private customerService: CustomerService,
    private guiLogicService : GUILogicService, private articleService: ArticleService,
    private stockSearchService: StockSearchService) {
    this.orderList = [];
    this.msgs = [];

    this.dataChartKPI = {
      datasets: [{
        data: [
          11,
          16,
          7,
          3,
          14
        ],
        backgroundColor: [
          "#FF6384",
          "#4BC0C0",
          "#FFCE56",
          "#E7E9ED",
          "#36A2EB"
        ],
        label: 'My dataset'
      }],
      labels: [
        "Offen",
        "Erledigt",
        "Inarbeit",
        "Angehalten",
        "Freigegeben"
      ]
    }
  }

  ngOnInit() {
    this.loadOrders();
  }

  private loadOrders() {
    this.orderMap = [];
    this.orderService.list().subscribe(
      (orderArray: Order[]) => {
        console.log('Received list of orders: ' + orderArray.length);

        this.orderList = [];
        for (var order of orderArray) {
          let item: OrderListItem = new OrderListItem();

          item.id = order.id;
          item.hint = order.hint;
          item.gate = order.gate;
          item.order = order.order;
          item.state = order.state;
          if (order.positions != null)
            item.positionslength = order.positions.length;
          else
            item.positionslength = 0;

          // qry customer from service
          this.customerService.qryCustomer(order.customerid).subscribe(
            (customer: Customer) => {
              if (customer != null)
                item.customer = customer;
              else
                item.customer = new Customer();
            },
            (err) => {
              console.log(err);
              item.customer = new Customer();
            }
          )

          this.orderMap[order.id] = order;
          this.orderList = [...this.orderList, item];
        }
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of orders.' });
      }
    );
  }

  public addNew() {
    console.log('Navigate to new order component.');
    this.router.navigateByUrl('/order/new');
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedOrder == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Warenausgang ausgewaehlt.' });
      return;
    }

    this.router.navigate(['/order', this.selectedOrder.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedOrder == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Warenausgang ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Warenausgang wirlich loeschen?',
      accept: () => {
        this.orderService.delete(this.selectedOrder.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Warenausgang wurde geloescht.' });
              this.loadOrders();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Warenausgang konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Warenausgang konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  public releaseSelected() {
    this.msgs = [];
    if (this.selectedOrder == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Warenausgang ausgewaehlt.' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Moechten Sie den Warenausgang wirlich freigeben?',
      accept: () => {
        for(var orderPos of this.orderMap[this.selectedOrder.id].positions) {
          let request : StockSearchRequest = new StockSearchRequest();
          request.orderpos = orderPos;
          request.order = this.orderMap[this.selectedOrder.id];
          request.customer = this.selectedOrder.customer;
          request.destinationLocationId = +this.selectedOrder.gate;
          request.quantityQueried = orderPos.qtyExpected - orderPos.qtyReceived;
          
          this.articleService.qryArticle(orderPos.articleid).subscribe(
            (article : Article) => {
              request.article = article;
              this.stockSearchService.search(request).subscribe(
                (success : any) => {
                  console.log("Result: " + JSON.stringify(success));
                },
                (err : any) => {
                  this.msgs.push({ severity: 'warn', summary: 'Warenausgangsposition konnte nicht freigegeben werden.' });
                  console.log('Error on serverside: search failed: '+JSON.stringify(err));
                }
              );
            }, 
            (err : any) => {
              this.msgs.push({ severity: 'warn', summary: 'Warenausgangsposition konnte nicht freigegeben werden.' });
              console.log('Error on serverside: article not found: '+ JSON.stringify(err));
            }
          )
        }
        
        /*this.orderService.delete(this.selectedOrder.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Warenausgang wurde freigegeben.' });
              this.loadOrders();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Warenausgang konnte nicht freigegeben werden.' });
              console.log('Error on serverside.');
            }
          }
        );*/
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/order/order.component.ts